module.exports = __webpack_public_path__ + "img/background-monuments.7e9cb829.svg";